import React, { useEffect } from "react";

// IMPORT COMPONENTS
import Navbar from "components/Navbar/Navbar";
import MediaQuery from "react-responsive";
import SidebarDesktop from "components/sidebar/SidebarDesktop";
import SidebarMobile from "components/sidebar/SidebarMobile";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import UseContext from "hooks/useContext";
import Usefetchdata from "hooks/usefetchdata";
import Intercom from '@intercom/messenger-js-sdk';
import CryptoJS from 'crypto-js';
import useHideIntercomLauncher from "hooks/useHideIntercomLauncher";
import getToastTransition from "components/pageForm/toastTransition";

const PageForm = (props) => {
    const { sidebarOpen, setSidebarOpen, slideOverShow, modalShow } = UseContext();
    const { userData } = Usefetchdata();

    useEffect(() => {
        if (Object.keys(userData).length > 0) {
            const userIdentifier = userData._id.toString();
            const hash = CryptoJS.HmacSHA256(userIdentifier, process.env.REACT_APP_INTERCOM_ID).toString();
            Intercom({
                app_id: 'hq7jtuxz',
                user_id: userData._id,
                user_hash: hash,
                name: userData.firstname + ' ' + userData.lastname,
                email: userData.email,
                created_at: userData.createdAt,
                app_type: "Admin",
                role_id: userData.role,
            });
        }
    }, [userData]);

    // Hidden while a slide-over, a modal or any aria-modal panel is open.
    useHideIntercomLauncher(slideOverShow || modalShow, userData);

    return (
        <>
            <div className="flex h-screen overflow-y-hidden tab:overflow-hidden relative">
                {/* Overlay noir - visible uniquement sur mobile quand sidebar ouverte */}
                {sidebarOpen && (
                    <div
                        className="fixed inset-0 tab:hidden transition-opacity duration-200"
                        style={{ 
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            zIndex: 35 
                        }}
                        onClick={() => setSidebarOpen(false)}
                    />
                )}
                {/* Sidebar - rendue sur tous les écrans, cachée par défaut sur mobile */}
                <SidebarDesktop/>
                {/* Navbar mobile - uniquement sur mobile */}
                <MediaQuery maxWidth={768}><SidebarMobile/></MediaQuery>
                {/* Content area */}
                <div className="flex flex-col flex-1 overflow-y-auto overflow-x-hidden">
                    {/* Navbar */}
                    <Navbar></Navbar>
                    <main className={'w-full h-full flex flex-col overflow-y-auto'}>
                        {/* SubNav */}
                        {/*<div className="w-full">*/}
                        {/*    <SecondNavBar/>*/}
                        {/*</div>*/}
                        {/* Main Content */}
                        <div className="flex flex-col w-full h-full bg-white tab:pb-0 pb-20 motion-safe:animate-contentIn">{props.children}</div>
                    </main>
                </div>
            </div>
            <ToastContainer
                position="bottom-left"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                limit={2}
                pauseOnFocusLoss
                draggable
                transition={getToastTransition()}
            />
        </>
    );
};

export default PageForm;